import { Component, OnInit } from '@angular/core';
import { Product } from '../../models/Product.model';
import { ConnectionService } from '../../services/connection.service';

@Component({
  selector: 'app-list',
  templateUrl: './list.component.html',
  styleUrls: ['./list.component.css']
})
export class ProductComponent implements OnInit {
  products: Product[]

  product: any = {}

  updateItem: any = {}

  costItem: any = {}

  calculation: any = {
    gain: '',
  }

  gain: any = {}

  sales_price: any = {}

  sales_price_component = false

  sales_gain: any = {}

  constructor(private connection: ConnectionService) { }

  ngOnInit() {
    this.connection.getProducts()
    .subscribe(data => this.products = data)
  }

  delete(product) {
    this.connection.deleteProduct(product)
  }

  update(product) {
    this.updateItem = product
  }

  addUpdatedItem() {
    this.connection.updateProduct(this.updateItem)
  }

  costs(product){
    this.costItem = product
    
    this.connection.getProduct(this.costItem.id)
    .subscribe(data => this.product = data)
  }

  calculationItems(investment){
    //porcentaje de ganancia * inversion
    this.sales_price_component = true
    this.gain = this.calculation.gain * investment
    this.sales_price = this.gain + investment
    this.sales_gain = this.sales_price - investment
    console.log(this.sales_price)
  }

  clean(){
    this.sales_price_component = false
    this.gain = ''
    this.sales_price = ''
    this.sales_gain = ''
  }

}
